import tinykeys from 'tinykeys';

interface KeyboardShortcutDictionary {
  [index: string]: (event: KeyboardEvent) => void;
}

export enum Module {
  General = 'General',
}

export interface KeyboardAction {
  title: string;
  module: Module;
  //For usage, https://github.com/jamiebuilds/tinykeys#usage
  shortcut: string;
  run: (event?: KeyboardEvent) => void;
  bypassFocusedElements?: boolean;
}

function checkActiveElementRestricted() {
  const currentActiveElement = document.activeElement?.tagName;

  switch (currentActiveElement) {
    case 'INPUT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
}

function getKeyboardShortcuts(actions: KeyboardAction[]) {
  const shortcuts: KeyboardShortcutDictionary = {};

  actions.forEach((action) => {
    const { shortcut, run, bypassFocusedElements } = action;

    shortcuts[shortcut] = (event: KeyboardEvent) => {
      if (!bypassFocusedElements) {
        const isActiveElementRestricted = checkActiveElementRestricted();
        if (isActiveElementRestricted) {
          return;
        }
      }

      event.preventDefault();
      run(event);
    };
  });

  return shortcuts;
}

export function initKeyboardshortcuts(
  shortcutActions: KeyboardAction[],
): () => void {
  const shortcuts = getKeyboardShortcuts(shortcutActions);
  return tinykeys(window, shortcuts);
}
